import { EAuctionLotLabel } from 'src/_config/enumerations'
import { BidderStatus } from '../../../../core/constants'

export interface AuctionResponse {
    id: number
    title: string
    messageId: string | null
    auctionStatus: number
    auctionFormat: string
    auctionFormatLabelId: EAuctionLotLabel | null
    auctionFormatLabel: string | null
    saleType: string | null
    lots: any[]
    bidderAccount: BidderAccount | null
    saleTypeEnum: number | null
    startsAt?: Date
    auctionActivityStatus: number | null
}

export interface BidderAccount {
    id: number
    bidderNumber: number
    accountName?: string
    bidStatus: BidderStatus
}

export interface AuctionNotificationResponse {
    auctionId: number | null
    notifications: AuctionNotification[]
}

export interface AuctionNotification {
    id?: number
    message: string
    createdAt: Date
    createdBy?: number
    type?: AnnouncementType
    recipientAuctionBidderId?: number
    title?: string
}

export enum AnnouncementType {
    Public = 1,
    Private = 2
}

export enum AuctionFormatLabel {
    Hybrid,
    Sequential,
    Saleyard
}

export interface AuctionConfigurationResponse {
    auctionTypes: { key: string; value: string; order?: number }[]
    agencies: {
        id: number
        name: string
        address1?: string
        address2?: string
        address3?: string
        website?: string
        status: number
    }[]
    auctionFormats: { key: string; value: string; order?: number }[]
    auctionFormatLabels: { key: string; value: string; order?: number }[]
    saleyards: Saleyard[]
    vendorTypes: { key: string; value: string; order?: null }[]
    marketOperators: {
        id: number
        subjectId: string
        firstName: string
        lastName: string
        emailAddress: string
        roleInfoUrl: string
        statusId: number
        role: {
            name: string
            key: string
        }
    }[]
    pricingOptions: {
        key: string
        value: string
        order: number
    }[]
    saleTypes: {
        id: number
        name: string
        type: number
    }[]
}

export interface FloorBidder {
    id: number
    firstName: string
    lastName: string
    accountName: string
    accountNumber: string
}

export interface Saleyard {
    id: number
    name: string
    collectionAddress1: string
    collectionAddress2: string
    collectionTown: string
    collectionPostalCode: string
    floorBidder: FloorBidder
    primaryStreamName: string
    secondaryStreamName: string
    adminEmailOne: string
    adminEmailTwo: string
    adminEmailThree: string

    // for the forms
    label: string
    value: number
}
